// @flow
import type { FetchCurrentUserResponse } from '../types';
import userFactory from '../factories/userFactory';

export default (opts: Object = {}): FetchCurrentUserResponse => ({
  authenticated: false,
  currentUser: userFactory(),
  realUser: userFactory(),
  ...opts,
});



// WEBPACK FOOTER //
// ../react-lib/src/factories/fetchCurrentUserResponseFactory.js